import { brandRoute, getBrandPrefix } from "./restaurantSlugDetector";

/**
 * Brand-aware history push
 * Automatically adds brand prefix to routes
 * 
 * Usage:
 * brandPush(history, '/cart')
 * Result: history.push('/suguna-chicken/cart') if brand context
 */
export const brandPush = (history, path) => {
	const brandScopedPath = brandRoute(path);
	history.push(brandScopedPath);
};

/**
 * Brand-aware history replace
 */
export const brandReplace = (history, path) => {
	const brandScopedPath = brandRoute(path);
	history.replace(brandScopedPath);
};

/**
 * Check if we're in brand context
 */
export const isInBrandContext = () => {
	return getBrandPrefix() !== null;
};

/**
 * Get current brand slug or null
 */
export const getCurrentBrand = () => {
	return getBrandPrefix();
};

